import { General } from '@/services/General';

export class Process {
    public ProcessId: string;
    public CurrentStep: string;
    public Status: string;
    public Type: string;
    public Username: string;
    public Percentage: number;
    public ErrorDescription: string;
    public StartDate: Date;
    public EndDate: Date;
    public Description: string;
    public ProcessedOutput: any;
 
    constructor(
        ProcessId?: string,
        CurrentStep?: string,
        Status?: string,
        Type?: string,
        Username?: string,
        Percentage?: number,
        ErrorDescription?: string,
        StartDate?: Date,
        EndDate?: Date,
        Description?: string,
        ProcessedOutput?: any
      ) {
        this.ProcessId = ProcessId;
        this.CurrentStep = CurrentStep;
        this.Status = Status;
        this.Type = Type;
        this.Username = Username;
        this.Percentage = Percentage;
        this.ErrorDescription = ErrorDescription;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Description = Description;
        this.ProcessedOutput = ProcessedOutput;
      }
    
}